module.exports = __webpack_public_path__ + "static/volleraux-1c895c32002e9ed6d48fa1dc6b1af9d8.png";